import { render, staticRenderFns } from "./BlobIcon.vue?vue&type=template&id=a08120c6&"
import script from "./BlobIcon.vue?vue&type=script&lang=js&"
export * from "./BlobIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports